import { createI18n } from 'vue-i18n'

const fileNameToLocaleModuleDict = import.meta.glob<{ default: Record<string, string> }>('./locales/*.json', {
  eager: true,
})

const messages: { [P: string]: Record<string, string> } = {}
Object.entries(fileNameToLocaleModuleDict)
  .map(([fileName, localeModule]) => {
    const fileNameParts = fileName.split('/')
    const fileNameWithoutPath = fileNameParts[fileNameParts.length - 1]
    const localeName = fileNameWithoutPath.split('.json')[0]

    return [localeName, localeModule.default] as const
  })
  .forEach((localeNameLocaleMessagesTuple) => {
    messages[localeNameLocaleMessagesTuple[0]] = localeNameLocaleMessagesTuple[1]
  })

const i18n = createI18n({
  legacy: false,
  locale: 'gb',
  fallbackLocale: 'gb',
  messages,
})

export default i18n

// ── Named exports consumed by components ──────────────────────────────────────

export type Locale = 'gb' | 'br' | 'cn' | 'es' | 'ir' | 'sw'

export const supportedLocales: { value: Locale; label: string }[] = [
  { value: 'gb', label: 'English (UK)' },
  { value: 'br', label: 'Português (BR)' },
  { value: 'cn', label: '中文' },
  { value: 'es', label: 'Español' },
  { value: 'ir', label: 'فارسی' },
  { value: 'sw', label: 'Kiswahili' },
]

export function setLocale(locale: Locale): void {
  ;(i18n.global.locale as any).value = locale
}
